// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceFilledSvg from "@fishx/icons-svg/es/asn/CustomerServiceFilled";
import FishxIcon from '../components/FishxIcon';

var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceFilledSvg
  }));
};

CustomerServiceFilled.displayName = 'CustomerServiceFilled';
export default React.forwardRef(CustomerServiceFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CustomerServiceFilled.js
// module id = 2362
// module chunks = 0